import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const timezoneMap = {
  hk: 8,
  tw: 8,
  cn: 8,
  en: 8,
  sg: 8,
  my: 8,
  ph: 8,
  id: 7,
  th: 7,
  vi: 7,
}

export const getItemName = (id, t, te) => {
  const rawId = String(id ?? '')
  if (!rawId) return ''

  const key = `ann2026.item.${rawId}`
  return te(key) ? t(key) : rawId
}

export const parseProps = (raw) => {
  if (raw == null || raw === '') return []

  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    if (Array.isArray(parsed)) return parsed
    return parsed && typeof parsed === 'object' ? [parsed] : []
  } catch {
    return []
  }
}

export const getRewardId = (reward = {}) =>
  reward.itemId ??
  reward.propId ??
  reward.id ??
  reward.rewardId ??
  reward.itemCode ??
  reward.propCode ??
  reward.rewardCode ??
  ''

export const getRewardCount = (reward = {}) =>
  reward.quantity ??
  reward.propCount ??
  reward.count ??
  reward.num ??
  reward.itemCount ??
  1

/** 从接口响应/配置项里取出奖励数组，字段名各接口不统一，逐个降级 */
export const pickRewardList = (source) => {
  if (!source) return []
  if (Array.isArray(source) || typeof source === 'string') return parseProps(source)

  const fields = [
    source.rewardItems,
    source.rewardList,
    source.rewards,
    source.items,
    source.itemList,
    source.propSnapshot,
    source.propInfo,
  ]
  for (const field of fields) {
    const parsed = parseProps(field)
    if (parsed.length) return parsed
  }

  // 响应本身就是单个奖励对象
  return getRewardId(source) ? [source] : []
}

/** 埋点奖励明细：JSON 字符串 [{ id, count }]，不带道具名 */
export const toTrackRewards = (source) =>
  JSON.stringify(
    pickRewardList(source).map((item) => ({
      id: getRewardId(item),
      count: getRewardCount(item),
    })),
  )

export const formatTime = (timestamp, locale) => {
  if (!timestamp) return '-'

  const offset = timezoneMap[locale] ?? 8
  const parsed = dayjs.utc(timestamp)
  return parsed.isValid()
    ? parsed.utcOffset(offset).format('YYYY/M/D HH:mm')
    : String(timestamp)
}
